var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlugIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#7ADB78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.666 29.5C31.666 28.6716 30.9944 28 30.166 28H20.666C17.9046 28 15.666 25.7614 15.666 23C15.666 20.2386 17.9046 18 20.666 18H23.666V20H20.666C19.0092 20 17.666 21.3432 17.666 23C17.666 24.6569 19.0092 26 20.666 26H30.166C32.099 26 33.666 27.567 33.666 29.5C33.666 31.433 32.099 33 30.166 33H16.666C16.1137 33 15.666 32.5523 15.666 32C15.666 31.4477 16.1137 31 16.666 31H30.166C30.9944 31 31.666 30.3284 31.666 29.5Z",
    fill: "#0E0C15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.666 16H28.666V18H32.666C33.2183 18 33.666 17.5523 33.666 17C33.666 16.4477 33.2183 16 32.666 16Z",
    fill: "#0E0C15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.666 20H28.666V22H32.666C33.2183 22 33.666 21.5523 33.666 21C33.666 20.4477 33.2183 20 32.666 20Z",
    fill: "#0E0C15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.666 19C21.666 16.7909 23.4569 15 25.666 15H29.666C30.2183 15 30.666 15.4477 30.666 16V22C30.666 22.5523 30.2183 23 29.666 23H25.666C23.4569 23 21.666 21.2091 21.666 19Z",
    fill: "#0E0C15"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugIcon);
export default __webpack_public_path__ + "static/media/plugIcon.af4334b9777863736fe878a590351900.svg";
export { ForwardRef as ReactComponent };